export const types = {
    vnpay: "VNPay",
    momo: "Momo",
}
